import List from '../Hash.List.i18n';
import Detail from '../Hash.Detail.i18n';

export default {
  components: { List, Detail },
  data: () => ({ base: false, list: false, edit: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false) }
      else { this.detail = !(this.list = false); }
    }
  },
  created: function() {   console.log('hash.vue', 'created'); },
  destroyed: function() { console.log('hash.vue', 'destroyed'); },
  mounted: function() {
    console.log('hash.vue', 'mounted');
    this.select(this.$route.params);
  },
  watch: {
    '$route' (to, from) {
      console.log('hash.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
